/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { ReactNode, useMemo } from "react";
import { EditorContext, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import ListItem from "@tiptap/extension-list-item";
import BulletList from "@tiptap/extension-bullet-list";
import OrderedList from "@tiptap/extension-ordered-list";
import CharacterCount from "@tiptap/extension-character-count";

type TiptapEditorProviderProps = {
  children?: ReactNode;
};

export const TiptapEditorProvider = ({ children }: TiptapEditorProviderProps) => {
  const editor = useEditor({
    extensions: [StarterKit, Underline, ListItem, BulletList, OrderedList, CharacterCount.configure()],
  });

  const providerValue = useMemo(() => ({ editor }), [editor]);

  return <EditorContext.Provider value={providerValue}>{children}</EditorContext.Provider>;
};
